module.exports = __webpack_public_path__ + "img/edp-comercial.0a10b61c.png";